import { render, staticRenderFns } from "./customerPassRatio.vue?vue&type=template&id=363018cc&scoped=true&"
import script from "./customerPassRatio.vue?vue&type=script&lang=js&"
export * from "./customerPassRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363018cc",
  null
  
)

export default component.exports